import { Money } from "@redotech/money";
import { PaymentModel } from "@redotech/redo-return-coverage-common/coverage-calculator/utils/derive-payment-model";
import { Equal, booleanEqual, objectEqual } from "@redotech/util/equal";

export interface Coverage {
  exchange: boolean;
  storeCredit: boolean;
  refund: boolean;
}

export const coverageEqual: Equal<Coverage> = objectEqual({
  exchange: booleanEqual,
  refund: booleanEqual,
  storeCredit: booleanEqual,
});

const paymentModelWeights: { [K in PaymentModel]: number } = {
  customer_paid: 1,
  merchant_paid: 0.9,
};

export function paymentModelMultiplier(paymentModel: PaymentModel) {
  return paymentModelWeights[paymentModel];
}

export function pricePerOrder(
  coverage: Coverage,
  paymentModel: PaymentModel,
  base: Money,
): Money {
  const paymentModelWeight = paymentModelMultiplier(paymentModel);
  return {
    amount: +(+base.amount * paymentModelWeight).toFixed(2),
    currency: base.currency,
  };
}

export const bigcommerceFeeName = "redo_v1:";

export {
  PaymentModel,
  derivePaymentModel,
} from "@redotech/redo-return-coverage-common/coverage-calculator/utils/derive-payment-model";
